<template>
  <main id="error-layouts">
    <router-view />
  </main>
</template>

<script>
export default {
  name: "BaseError",
  created() {
    this.$store.dispatch("loading/setLoading", false)
  }
}
</script>
